import * as React from 'react';
import VideocamIcon from '@mui/icons-material/Videocam';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import StraightenIcon from '@mui/icons-material/Straighten';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { SvgIcon } from '@mui/material';
import { ProductPropertiesTypes, Order } from '../../BookingsCalendarTypes';
import { formatKeyPickupAddress } from '../../utils/keyPickupUtils';

interface ProductPropertiesIconsProps {
    order: Order;
    labels: ProductPropertiesIconsLabels;
}

type ProductPropertiesIconsLabels = {
    propertyTitle: (value: string) => string;
    images: string;
    photo: string;
};

let iconStyling = {
    width: '18px',
    height: '18px',
    color: '#333D45',
    margin: '4px',
};

const OrderListProductPropertiesIcons = (props: ProductPropertiesIconsProps) => {
    let { order, labels } = props;

    const properties = order.productProperties;
    const orderId = order.orderId;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {properties.length > 0 &&
                properties.map((property) => {
                    if (property.value === ProductPropertiesTypes.Film) {
                        return (
                            <Tooltip
                                title={labels.propertyTitle(property.displayName)}
                                key={`${orderId}` + ProductPropertiesTypes.Film}
                            >
                                <VideocamIcon sx={iconStyling} />
                            </Tooltip>
                        );
                    }
                    if (property.value === ProductPropertiesTypes.Measured) {
                        return (
                            <Tooltip
                                title={labels.propertyTitle(property.displayName)}
                                key={`${orderId}` + ProductPropertiesTypes.Measured}
                            >
                                <StraightenIcon sx={iconStyling} />
                            </Tooltip>
                        );
                    }
                    if (property.value === ProductPropertiesTypes.Matterport) {
                        return (
                            <Tooltip
                                title={labels.propertyTitle(property.displayName)}
                                key={`${orderId}` + ProductPropertiesTypes.Matterport}
                            >
                                <ThreeDRotationIcon sx={iconStyling} />
                            </Tooltip>
                        );
                    }
                    if (property.value === ProductPropertiesTypes.Drone) {
                        return (
                            <Tooltip
                                title={labels.propertyTitle(property.displayName)}
                                key={`${orderId}` + ProductPropertiesTypes.Drone}
                            >
                                <SvgIcon sx={{ color: '#333D45' }} viewBox="0 0 20 20">
                                    <path d="M3.9059 5.698C3.75519 5.69844 3.60793 5.74306 3.48233 5.82635C3.35674 5.90964 3.25833 6.02794 3.1993 6.1666C1.3411 6.2728 -0.00590341 6.4514 -0.000103412 6.591C0.00529659 6.7296 1.3423 6.7904 3.1855 6.7358C3.2495 6.9082 3.3727 7.0518 3.5331 7.1412H3.2339V7.6896H2.8679C2.84492 7.68957 2.82217 7.69408 2.80094 7.70285C2.77971 7.71162 2.76042 7.72449 2.74416 7.74073C2.72791 7.75696 2.71502 7.77624 2.70622 7.79746C2.69742 7.81868 2.6929 7.84143 2.6929 7.8644V8.2552C2.6929 8.3518 2.7711 8.43 2.8677 8.43H5.3309C5.9515 8.576 6.0209 8.7986 6.4857 9.206C6.4097 9.6286 6.2977 10.09 6.2101 10.4888V13.8834C6.2101 13.9944 6.25419 14.1008 6.33267 14.1793C6.41116 14.2578 6.5176 14.3019 6.6286 14.3019C6.73959 14.3019 6.84604 14.2578 6.92452 14.1793C7.003 14.1008 7.0471 13.9944 7.0471 13.8834V12.242C7.0375 10.862 7.2603 10.304 8.0281 9.2358L8.2211 9.1462C8.2211 9.9754 8.7943 10.0252 9.6027 10.2102H8.9955C8.8107 10.2102 8.6607 10.3602 8.6607 10.5452V12.5452C8.6607 12.73 8.8107 12.88 8.9955 12.88H11.0043C11.1891 12.88 11.3391 12.73 11.3391 12.5452V10.5452C11.3391 10.3602 11.1891 10.2104 11.0043 10.2104H10.3977C11.2059 10.0248 11.7787 9.9752 11.7787 9.1462L11.9717 9.2358C12.9431 10.241 12.9527 10.9252 12.9527 12.2418V13.8832C12.9527 13.9942 12.9968 14.1006 13.0753 14.1791C13.1538 14.2576 13.2602 14.3017 13.3712 14.3017C13.4822 14.3017 13.5886 14.2576 13.6671 14.1791C13.7456 14.1006 13.7897 13.9942 13.7897 13.8832V10.4888C13.6871 10.0506 13.5773 9.5914 13.4737 9.1364C13.9135 8.7054 14.0939 8.6084 14.6649 8.43H17.1321C17.1785 8.43 17.2229 8.41158 17.2557 8.3788C17.2885 8.34602 17.3069 8.30156 17.3069 8.2552V7.8644C17.3069 7.81804 17.2885 7.77358 17.2557 7.7408C17.2229 7.70802 17.1785 7.6896 17.1321 7.6896H16.7659V7.1412H16.4667C16.6272 7.05183 16.7505 6.90805 16.8143 6.7358C18.6575 6.7904 19.9945 6.7296 19.9999 6.591C20.0057 6.4514 18.6587 6.273 16.8005 6.1666C16.7435 6.03288 16.6499 5.91801 16.5304 5.83525C16.4109 5.75249 16.2704 5.70522 16.1252 5.69891C15.98 5.69259 15.836 5.72748 15.7097 5.79955C15.5835 5.87163 15.4803 5.97793 15.4119 6.1062C13.5505 6.0496 12.1913 6.1098 12.1835 6.2494C12.1777 6.388 13.5065 6.5654 15.3489 6.6718C15.3759 6.77056 15.4224 6.86293 15.4855 6.94353C15.5487 7.02413 15.6273 7.09133 15.7167 7.1412H15.4175V7.6896C13.5307 7.6852 12.0703 6.737 9.9999 6.698C7.9993 6.7404 6.3239 7.6896 4.5823 7.6896V7.1412H4.2831C4.37252 7.09133 4.4511 7.02413 4.51426 6.94353C4.57741 6.86293 4.62386 6.77056 4.6509 6.6718C6.4933 6.5654 7.8221 6.3878 7.8163 6.2494C7.8085 6.1098 6.4493 6.0494 4.5879 6.1062C4.52203 5.98264 4.42373 5.87936 4.30357 5.80747C4.1834 5.73559 4.04592 5.69761 3.9059 5.698ZM9.9999 10.7006C10.4693 10.7006 10.8551 11.0864 10.8551 11.5558C10.8551 12.0252 10.4693 12.4112 9.9999 12.4112C9.53049 12.4112 9.1443 12.0252 9.1443 11.5558C9.1443 11.0864 9.53029 10.7006 9.9999 10.7006ZM9.9999 11.2026C9.8019 11.2026 9.6465 11.3578 9.6465 11.5558C9.6465 11.7538 9.8019 11.909 9.9999 11.909C10.1979 11.909 10.3529 11.7538 10.3529 11.5558C10.3529 11.3578 10.1979 11.2026 9.9999 11.2026Z" />
                                </SvgIcon>
                            </Tooltip>
                        );
                    }
                    if (property.value === ProductPropertiesTypes.KeyPickup) {
                        const address = formatKeyPickupAddress(order);
                        return (
                            <Tooltip
                                title={address || labels.propertyTitle(property.displayName)}
                                key={`${orderId}` + ProductPropertiesTypes.KeyPickup}
                            >
                                <VpnKeyOutlinedIcon sx={iconStyling} />
                            </Tooltip>
                        );
                    } else return null;
                })}
        </Box>
    );
};

export default OrderListProductPropertiesIcons;
